import React from 'react';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const HomeRedesignMarquee: React.FC = () => {
  const { marquee } = useHomeRedesignStrings();

  const renderItems = (keyPrefix: string) =>
    marquee.items.map((item, i) => (
      <React.Fragment key={`${keyPrefix}-${i}`}>
        <p
          className={`whitespace-nowrap font-instrument text-2xl italic leading-snug tracking-[-0.01em] sm:text-3xl sm:leading-snug lg:text-[56px] lg:leading-[1.18] lg:tracking-[-0.015em] ${
            item.variant === 'pink' ? 'text-chisme-primary' : 'text-[#2a0f2a]'
          }`}
        >
          {item.label}
        </p>
        <span className="font-jakarta text-lg text-[#5a3158]/40 sm:text-2xl lg:text-[30px]">✿</span>
      </React.Fragment>
    ));

  return (
    <div className="border-y border-[rgba(74,33,71,0.1)] bg-[#faf1e8] py-5 lg:py-7">
      <div className="relative overflow-hidden py-1 lg:py-1.5">
        <div className="home-redesign-marquee-track flex w-max">
          <div className="flex items-center gap-6 pr-6 lg:gap-10 lg:pr-10">{renderItems('a')}</div>
          <div className="flex items-center gap-6 pr-6 lg:gap-10 lg:pr-10">{renderItems('b')}</div>
        </div>
      </div>
    </div>
  );
};

export default HomeRedesignMarquee;
